var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"mr-24-c",attrs:{"src":(_vm.publicPath + "assets/img/foto-default.png"),"height":"40"}})])}
var staticRenderFns = []

export { render, staticRenderFns }